import { Web3Provider } from '@ethersproject/providers'
import { ChainId } from '@bscswap/sdk'
import { useWeb3React as useWeb3ReactCore } from '@web3-react/core'
import { Web3ReactContextInterface } from '@web3-react/core/dist/types'
import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { injected } from '../connectors'
import { NetworkContextName } from '../constants'
import { ACTIVE_NETWORK } from '../connectors'
import { utils } from 'ethers'

const NETWORK_URL = process.env.REACT_APP_NETWORK_URL

export function useActiveWeb3React(): Web3ReactContextInterface<Web3Provider> & { chainId?: ChainId } {
  const context = useWeb3ReactCore<Web3Provider>()
  const contextNetwork = useWeb3ReactCore<Web3Provider>(NetworkContextName)
  return context.active ? context : contextNetwork
}

export function useEagerConnect() {
  const { activate, active } = useWeb3ReactCore() // specifically using useWeb3ReactCore because of what this hook does
  const [tried, setTried] = useState(false)

  useEffect(() => {
    console.log('called')
    injected.isAuthorized().then(isAuthorized => {
      console.log('called', isAuthorized)
      if (isAuthorized) {
        activate(injected, undefined, true).catch(() => {
          setTried(true)
        })
      } else {
        if (isMobile && window.ethereum) {
          activate(injected, undefined, true).catch(() => {
            setTried(true)
          })
        } else {
          setTried(true)
        }
      }
    })
  }, [activate]) // intentionally only running on mount (make sure it's only mounted once :))

  // useEffect(() => {
  //   binanceinjected.isAuthorized().then(isAuthorized => {
  //     if (isAuthorized) {
  //       activate(binanceinjected, undefined, true).catch(() => {
  //         setTried(true)
  //       })
  //     } else {
  //       if (isMobile && window.BinanceChain) {
  //         activate(binanceinjected, undefined, true).catch(() => {
  //           setTried(true)
  //         })
  //       } else {
  //         setTried(true)
  //       }
  //     }
  //   })
  // }, [activate]) // intentionally only running on mount (make sure it's only mounted once :))

  // if the connection worked, wait until we get confirmation of that to flip the flag
  useEffect(() => {
    if (active) {
      setTried(true)
    }
  }, [active])

  return tried
}

/**
 * Use for network and injected - logs user in
 * and out after checking what network theyre on
 */
export function useInactiveListener(suppress = false) {
  const { active, error, activate, chainId } = useWeb3ReactCore() // specifically using useWeb3React because of what this hook does

  useEffect(() => {
    const { ethereum, BinanceChain } = window
    if (BinanceChain && BinanceChain.switchNetwork && active && !ACTIVE_NETWORK.includes(chainId)) {
      BinanceChain.switchNetwork('bbc-testnet')
    }
    if (ethereum && ethereum.request && active && !ACTIVE_NETWORK.includes(chainId)) {
      try {
        ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: utils.hexlify(ACTIVE_NETWORK) }]
        })
      } catch (switchError) {
        // This error code indicates that the chain has not been added to MetaMask.
        // if (switchError.code === 4902) {
        //   try {
        //     ethereum.request({
        //       method: 'wallet_addEthereumChain',
        //       params: [
        //         {
        //           chainId: utils.hexlify(ACTIVE_NETWORK),
        //           chainName: 'bbc-testnet',
        //           rpcUrls: [NETWORK_URL] /* ... */,
        //         },
        //       ],
        //     });
        //   } catch (addError) {
        //     // handle "add" error
        //   }
        // }
        // handle other "switch" errors
      }
    }

    if (ethereum && ethereum.on && !active && !error && !suppress) {
      const handleChainChanged = () => {
        // eat errors
        activate(injected, undefined, true).catch(error => {
          console.error('Failed to activate after chain changed', error)
        })
        if (ethereum && ethereum.request && active && !ACTIVE_NETWORK.includes(chainId)) {
          ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: utils.hexlify(ACTIVE_NETWORK) }]
          })
        }
      }

      const handleAccountsChanged = (accounts: string[]) => {
        if (accounts.length > 0) {
          // eat errors
          activate(injected, undefined, true).catch(error => {
            console.error('Failed to activate after accounts changed', error)
          })
        }
      }

      ethereum.on('chainChanged', handleChainChanged)
      ethereum.on('accountsChanged', handleAccountsChanged)

      return () => {
        if (ethereum.removeListener) {
          ethereum.removeListener('chainChanged', handleChainChanged)
          ethereum.removeListener('accountsChanged', handleAccountsChanged)
        }
      }
    }
    return
  }, [active, error, suppress, activate, chainId])
}
